import { parseToOldApiOrdering } from '../../../../utils/sort'

export function getTableModalLoadingDataRequestParams({
  ordering,
  page,
  pageSize,
  paginationPageSizeKey,
  search,
}) {
  return {
    ...(search ? { search } : null),
    ...(ordering ? parseToOldApiOrdering(ordering) : null),
    page,
    [paginationPageSizeKey]: pageSize,
  }
}
